import {
	ACTION,
	ACTION_SUBJECT,
	ACTION_SUBJECT_ID,
	EVENT_TYPE,
} from '@atlaskit/editor-common/analytics';
import type { AIDefinitionsEventPayload } from '@atlaskit/editor-common/analytics';
import { ErrorUtils } from '@atlassian/editor-ai-common/utils/errors';

import type { OpenReadingAidsPopupSource } from '../../types';

const defineButtonClickedPayload = (
	readingAidsSessionId: string,
	wordCount: number,
): AIDefinitionsEventPayload => ({
	action: ACTION.CLICKED,
	actionSubject: ACTION_SUBJECT.BUTTON,
	actionSubjectId: ACTION_SUBJECT_ID.AI_DEFINITIONS_DEFINE_BUTTON,
	eventType: EVENT_TYPE.UI,
	attributes: {
		readingAidsSessionId,
		wordCount,
	},
});

const autoHighlightClickedPayload = (readingAidsSessionId: string): AIDefinitionsEventPayload => ({
	action: ACTION.CLICKED,
	actionSubject: ACTION_SUBJECT.DECORATION,
	actionSubjectId: ACTION_SUBJECT_ID.AI_DEFINITIONS_AUTO_HIGHLIGHT,
	eventType: EVENT_TYPE.UI,
	attributes: {
		readingAidsSessionId,
	},
});

export const getOpenReadingAidsPopupAnalyticsPayload = ({
	source,
	readingAidsSessionId,
	wordCount,
}: {
	readingAidsSessionId: string;
	source: OpenReadingAidsPopupSource;
	wordCount: number;
}): AIDefinitionsEventPayload => {
	return source === 'define-button-click'
		? defineButtonClickedPayload(readingAidsSessionId, wordCount)
		: autoHighlightClickedPayload(readingAidsSessionId);
};

export const getAIDefinitionsErrorAnalyticsPayload = ({
	error,
	errorInfo,
}: {
	error: unknown;
	errorInfo?: React.ErrorInfo;
}): AIDefinitionsEventPayload => {
	return {
		action: ACTION.ERRORED,
		actionSubject: ACTION_SUBJECT.AI_DEFINITIONS,
		eventType: EVENT_TYPE.OPERATIONAL,
		attributes: {
			errorMessage: ErrorUtils.extractErrorMessage(error),
			componentStack: errorInfo?.componentStack || '',
		},
	};
};
